// Reads a QCM written by the AI (A/B/C/D options + answer key) into quiz questions. Free: no AI call.
const clean = (s) => s.replace(/\*\*|__|`/g, "").replace(/^#{1,6}\s*/, "").replace(/^>\s?/, "").trim();
const KEY_HEAD = /^(?:[-–—•\s]*)(?:le\s+|les\s+)?(corrig[ée]s?|réponses|bonnes réponses|correction|solutions?|answer key|answers|key)(?!\p{L})/iu;
const OPTION = /^[-*•]?\s*\(?([A-Fa-f])\s*[).:]\s+(.+)$/;
const QUESTION = /^(?:question\s*|q\s*)?(\d{1,2})\s*(?:\([^)]*\))?\s*[.):\-–—]\s*(.+)$/i;
const QUESTION_ONLY = /^question\s*(\d{1,2})\s*(?:\([^)]*\))?\s*[:.\-–—]?\s*(.*)$/i;
const INLINE_ANSWER = /^(?:✅\s*)?(?:la\s+)?(?:bonne\s+)?(?:réponse|answer)(?:\s+(?:correcte|attendue|correct))?\s*[:：]\s*\(?([A-F])\b[).]?\s*[-–—:.]?\s*(.*)$/i;
const KEY_LINE = /^(?:question\s*|q\s*)?(\d{1,2})\s*[.):\-–—]*\s*(?:réponse\s*:?\s*|answer\s*:?\s*)?\(?([A-F])\b[).]?\s*[-–—:.,]?\s*(.*)$/i;
const EXPL = /^(?:justification|explication|explanation|pourquoi|why)\s*[:：]\s*(.+)$/i;
const MARK = /\s*(✅|✔️?|\(bonne réponse\)|\(correct\)|\(vrai\))\s*$/i;
const DIFF = /\s*\((?:niveau\s*:?\s*)?(?:facile|moyen(?:ne)?|difficile|easy|medium|hard)\)\s*/gi;

export function parseQcm(md = "") {
  const qs = [];
  const key = {};
  let cur = null;
  let inKey = false;
  let lastKey = null;
  for (const raw of md.split("\n")) {
    const line = clean(raw);
    if (!line) continue;
    if (/^(?:difficulté|niveau|difficulty)\s*:/i.test(line)) continue;
    if (line.length < 60 && KEY_HEAD.test(line) && !OPTION.test(line)) { inKey = true; continue; }
    if (inKey) {
      const k = line.match(KEY_LINE);
      if (k) { key[+k[1]] = { letter: k[2].toUpperCase(), expl: k[3] }; lastKey = +k[1]; continue; }
      const e = line.match(EXPL);
      if (lastKey && (e || !QUESTION.test(line))) key[lastKey].expl = [key[lastKey].expl, e ? e[1] : line].filter(Boolean).join(" ");
      continue;
    }
    const ia = line.match(INLINE_ANSWER);
    if (ia && cur) { cur.letter = ia[1].toUpperCase(); if (ia[2]) cur.expl = ia[2]; continue; }
    const ex = line.match(EXPL);
    if (ex && cur) { cur.expl = [cur.expl, ex[1]].filter(Boolean).join(" "); continue; }
    const op = line.match(OPTION);
    if (op && cur) {
      let text = op[2];
      if (MARK.test(text)) { text = text.replace(MARK, ""); cur.letter = op[1].toUpperCase(); }
      cur.options.push({ letter: op[1].toUpperCase(), text: text.trim() });
      continue;
    }
    const qm = line.match(QUESTION) || line.match(QUESTION_ONLY);
    if (qm && (!cur || cur.options.length)) {
      cur = { n: +qm[1], q: qm[2].replace(DIFF, " ").trim(), options: [], letter: null, expl: "" };
      qs.push(cur);
      continue;
    }
    if (cur && !cur.options.length) cur.q = `${cur.q} ${line.replace(DIFF, " ")}`.trim();
  }
  const out = qs
    .map((q) => {
      const letter = q.letter || key[q.n]?.letter;
      const answer = q.options.findIndex((o) => o.letter === letter);
      return { q: q.q, options: q.options.map((o) => o.text).slice(0, 6), answer, explanation: (q.expl || key[q.n]?.expl || "").trim().slice(0, 800) };
    })
    .filter((q) => q.q && q.options.length >= 2 && q.answer >= 0 && q.answer < q.options.length);
  return out.length >= 2 ? out.slice(0, 30) : null;
}
